import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/SawitK.css";
import axios from "axios";

const SawitPa = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [hargaSawit, setHargaSawit] = useState([]);
  const [currentPageSawit, setCurrentSawit] = useState(1);
  const itemsPerPage = 3;

  const [hargaPupuk, setHargaPupuk] = useState([]);

  // Format tanggal sesuai: DD/MM/YYYY, HH.mm
  const formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}.${minutes}`;
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(Number(value))) return "-";
    return new Intl.NumberFormat("id-ID").format(value);
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Error during logout:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchSawitData();
    fetchPupukData();
  }, []);

  const fetchSawitData = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_sawit",
        { withCredentials: true }
      );
      const sortedData = (response.data || []).map((item) => {
        if (Array.isArray(item.harga_usia)) {
          item.harga_usia.sort((a, b) => a.usia - b.usia);
        }
        return item;
      });
      setHargaSawit(sortedData);
    } catch (error) {
      console.error("Error fetching sawit data:", error);
    }
  };

  const fetchPupukData = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_pupuk",
        { withCredentials: true }
      );
      setHargaPupuk(response.data.pupuks || []);
    } catch (error) {
      console.error("Error fetching pupuk data:", error);
    }
  };

  const handlePageChangeSawit = (pageNumber) => {
    setCurrentSawit(pageNumber);
  };

  const totalPagesSawit = Math.ceil(hargaSawit.length / itemsPerPage) || 1;
  const currentSawitItems = hargaSawit.slice(
    (currentPageSawit - 1) * itemsPerPage,
    currentPageSawit * itemsPerPage
  );

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Table Style Overrides to match DataTables look */}
      <style>{`
        .custom-dt-table {
          border: 1px solid #e9ecef !important;
        }
        .custom-dt-table th {
          border-bottom: 1px solid #e9ecef !important;
          background-color: #ffffff !important;
          font-weight: 600 !important;
          color: #343a40 !important;
        }
        .custom-dt-table td {
          border-bottom: 1px solid #e9ecef !important;
          vertical-align: middle;
        }
        .sort-icon {
          color: #adb5bd;
          font-size: 0.8rem;
          margin-left: 5px;
        }
      `}</style>

      {/* Header */}
      <div className="header bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span
            className="fw-medium text-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/profile")}
          >
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1" style={{ width: "100%", overflowX: "hidden" }}>
        {/* Sidebar */}
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/pabrik" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/eco-home_7633847.png"
                alt="Home"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter: location.pathname === "/pabrik" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/pabrikt") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/shipping.png"
                alt="Transactions"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter: location.pathname.includes("/pabrikt") ? "brightness(0) invert(1)" : "none",
                }}
              />
              Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/pabrikh" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/packaging.png"
                alt="Results"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter: location.pathname === "/pabrikh" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Hasil
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div
          className="flex-grow-1 p-4"
          style={{
            width: "calc(100% - 240px)",
            minWidth: 0,
            overflowX: "hidden",
            backgroundColor: "#ffffff",
          }}
        >
          {/* Top Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div>
              <h1 className="fw-bold text-dark mb-2" style={{ fontSize: "2.2rem" }}>
                Katalog Sawit & Pupuk
              </h1>
              <p className="text-muted mb-0 fs-6">
                Pantau acuan harga pembelian Tandan Buah Segar (TBS) dan sarana produksi pupuk terkini.
              </p>
            </div>
            <div>
              <button
                className="btn btn-success rounded-pill px-4 py-2"
                onClick={handleBack}
              >
                Kembali
              </button>
            </div>
          </div>

          <hr className="mb-4" style={{ opacity: "0.1" }} />

          {/* Section 1: Daftar Harga Sawit Berdasarkan Usia */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="fw-bold text-success m-0">🏷️ Acuan Harga Beli Sawit (TBS)</h3>
            <span
              className="badge rounded-pill fw-medium"
              style={{ backgroundColor: "#d1e7dd", color: "#0f5132", padding: "8px 16px" }}
            >
              Total: {hargaSawit.length} Varietas Terdaftar
            </span>
          </div>

          {currentSawitItems && currentSawitItems.length > 0 ? (
            <div className="row g-4 mb-4">
              {currentSawitItems.map((item, index) => (
                <div className="col-12" key={`sawit-card-${item.id || index}`}>
                  <div className="bg-white rounded-4 border mb-4">
                    {/* Header Card Varietas */}
                    <div className="p-4 border-bottom d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <span className="badge bg-success rounded-pill px-3 py-2 fs-6">
                          #{ (currentPageSawit - 1) * itemsPerPage + index + 1 }
                        </span>
                        <h4 className="fw-bold text-dark mb-0 ms-2 text-capitalize">
                          Sawit {item.nama}
                        </h4>
                      </div>
                      <span className="text-muted fs-6">
                        {Array.isArray(item.harga_usia) ? item.harga_usia.length : 0} Kategori Usia
                      </span>
                    </div>

                    <div className="p-4">
                      {/* Table Tingkat Usia */}
                      {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table custom-dt-table mb-0">
                            <thead>
                              <tr>
                                <th className="py-3 px-4" style={{ width: "30%" }}>
                                  Usia Tanaman <i className="fa fa-sort sort-icon"></i>
                                </th>
                                <th className="py-3 px-4 text-center" style={{ width: "35%" }}>
                                  Harga Beli / Kg <i className="fa fa-sort sort-icon"></i>
                                </th>
                                <th className="py-3 px-4 text-center" style={{ width: "35%" }}>
                                  Tanggal Diperbarui <i className="fa fa-sort sort-icon"></i>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.harga_usia.map((data, idx) => (
                                <tr key={`hu-${idx}`}>
                                  <td className="py-3 px-4">
                                    <span className="badge bg-white text-dark border border-secondary-subtle px-3 py-2 rounded-pill fw-medium shadow-sm" style={{ fontSize: "0.85rem" }}>
                                      🌳 {data.usia} Tahun
                                    </span>
                                  </td>
                                  <td className="py-3 px-4 text-center">
                                    <span className="font-monospace text-success fw-bold fs-6">
                                      Rp {formatNumber(data.harga)}
                                    </span>
                                  </td>
                                  <td className="py-3 px-4 text-center text-muted">
                                    {formatDate(data.tanggal)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="p-4 text-center text-muted small fst-italic border rounded-3">
                          Belum ada parameter harga untuk varietas ini.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5 text-muted bg-light rounded-4 border shadow-sm mb-4">
              <i className="fa fa-seedling mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
              <h5 className="fw-semibold">Belum Ada Data Sawit</h5>
              <p className="mb-0">Daftar harga acuan varietas sawit belum tersedia.</p>
            </div>
          )}

          {/* Pagination Sawit */}
          {totalPagesSawit > 1 && (
            <nav className="mb-5">
              <ul className="pagination justify-content-end mb-0">
                <li className={`page-item ${currentPageSawit === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link shadow-none"
                    onClick={() => handlePageChangeSawit(currentPageSawit - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPagesSawit)].map((_, index) => (
                  <li
                    key={`page-sw-${index + 1}`}
                    className={`page-item ${currentPageSawit === index + 1 ? "active" : ""}`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => handlePageChangeSawit(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPageSawit === totalPagesSawit || totalPagesSawit === 0 ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link shadow-none"
                    onClick={() => handlePageChangeSawit(currentPageSawit + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          )}

          <hr className="mb-4" style={{ opacity: "0.1" }} />

          {/* Section 2: Table Container Harga Pupuk */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="fw-bold text-success m-0">🧪 Daftar Harga Pupuk</h3>
            <span
              className="badge rounded-pill fw-medium"
              style={{ backgroundColor: "#d1e7dd", color: "#0f5132", padding: "8px 16px" }}
            >
              Total: {hargaPupuk.length} Jenis
            </span>
          </div>

          <div className="bg-white p-4 border rounded-4 mb-4">
            {Array.isArray(hargaPupuk) && hargaPupuk.length > 0 ? (
              <div className="table-responsive">
                <table className="table custom-dt-table mb-0">
                  <thead>
                    <tr>
                      <th className="text-center py-3 px-3" style={{ width: "10%" }}>
                        No <i className="fa fa-sort sort-icon"></i>
                      </th>
                      <th className="py-3 px-4" style={{ width: "50%" }}>
                        Nama Pupuk <i className="fa fa-sort sort-icon"></i>
                      </th>
                      <th className="py-3 px-4 text-center" style={{ width: "40%" }}>
                        Harga per Kg <i className="fa fa-sort sort-icon"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {hargaPupuk.map((pupuk, index) => (
                      <tr key={`pupuk-${pupuk.id || index}`}>
                        <td className="text-center fw-bold text-muted py-3 px-3">{index + 1}</td>
                        <td className="fw-semibold text-dark py-3 px-4 text-capitalize">
                          {pupuk.nama}
                        </td>
                        <td className="text-center font-monospace text-success fw-bold py-3 px-4 fs-6">
                          Rp {formatNumber(pupuk.harga_per_kg)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 border">
                <i className="fa fa-boxes mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Pupuk</h5>
                <p className="mb-0">Data harga pupuk belum tersedia saat ini.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SawitPa;